export const chickenBreedOptions = [
  // Chicken breeds
  'Ameraucana',
  'Legbar',
  'Marans',
  'Plymouth Rock',
  'Other'
];

export const duckBreedOptions = ['Muscovy'];

export const speciesOptions = [
  'Chicken',
  'Duck', 
  'Goose',
  'Turkey'
];

export const sexOptions = [
  'Male',
  'Female'
];

export const characteristicOptions = [
  'Friendly',
  'Aggressive',
  'Broody',
  'Good Layer',
  'Cold Hardy',
  'Heat Tolerant',
  'Large',
  'Small',
  'Calm',
  'Active'
];

export const varietyOptions = [
  // Common color varieties
  'Black Copper',
  'Blue Copper',
  'Black Silver',
  'Blue Silver',
  'Barred',
  'Cuckoo',
  'Silver Cuckoo',
  // Other/custom option
  'Other'
];
